import React, { useEffect, useState, useCallback } from 'react';
import classnames from 'classnames';
import { useCurrency } from 'hooks/useCurrency';
import { useCurrencies } from 'api/currency/useCurrencies';

export default function CurrencySwitcher({ className }) {
  const { setCurrency, code: activeCode } = useCurrency();
  const [currencies, setCurrencies] = useState();
  const [showSwitcher, setShowSwitcher] = useState();
  const [, setSelectedCurrency] = useState();
  const { getCurrencies } = useCurrencies();

  const handleSetCurrency = async (event) => {
    setSelectedCurrency(event.target.value);
    await setCurrency(event.target.value);
    setShowSwitcher(false);
    window.location.reload();
  };

  const getAllCurrencies = useCallback(async () => {
    if (!currencies) {
      const {currencies} = await getCurrencies();
      setCurrencies(currencies);
    }
  }, [currencies, getCurrencies]);

  useEffect(() => {
    getAllCurrencies();
  }, [getAllCurrencies]);

  const handleToggleSwitcher = () => {
    setShowSwitcher(!showSwitcher);
  };

  return (currencies && activeCode) ? showSwitcher ? (
    <div className={classnames('flex items-center space-x-1', className)}>
      <button
        type="button"
        onClick={handleToggleSwitcher}
        className="hover:underline"
      >
        Change Currency -
      </button>

      <select
        className="max-w-sm w-full"
        onChange={handleSetCurrency}
        value={activeCode}
        style={{ color: '#333' }}
      >
        {Object.keys(currencies).map((code) => (
          <option key={code} value={code}>
            {code} ({currencies[code].sym})
          </option>
        ))}
      </select>
    </div>
  ) : (
    <button
      type="button"
      onClick={handleToggleSwitcher}
      className={classnames(
        'hover:underline inline-flex space-x-1 items-center',
        className
      )}
    >
      <span>Change Currency -</span><span> {activeCode} ({currencies[activeCode].sym})</span>
    </button>
  ) : (
    ''
  );
}
